module.exports = __webpack_public_path__ + "static/media/key-feed.d73fe4d0.png";